import { Injectable, signal } from '@angular/core'
import { AppUserRoles, UserInfo, AppConfig } from '@corporate-tailwind/model'
import { firstValueFrom } from 'rxjs'
import { AppSettingService } from '../app-setting/app-setting.service'
import { EnumAuthentification } from './authentification.enum'
import { UserApi } from './user.api'

@Injectable({ providedIn: 'root' })
export class UserStore {
    private readonly _user = signal<UserInfo | null>(null);
    private readonly _loading = signal<boolean>(true);

    // exposer les signals en lecture seule
    user = this._user.asReadonly();
    loading = this._loading.asReadonly();

    constructor(
        private _userApi: UserApi,
        private _appSettingService: AppSettingService
    ) { }

    loadUser() {
        this._loading.set(true)

        switch (this._appSettingService?.appSetting()?.authentification) {
            case EnumAuthentification[EnumAuthentification.anonymous]:
                this.getAnonyousUser()
                break

            case EnumAuthentification[EnumAuthentification.windows]:
                this.getManazUser()
                break
        }
    }

    private getAnonyousUser() {
        this._userApi.getAnonymousUser().subscribe({
            next: user => {
                this._user.set(user)
                this._loading.set(false)
            },
            error: err => {
                console.error('Erreur lors du chargement utilisateur', err)
                this._loading.set(false)
            }
        })
    }

    private async getManazUser() {
        this._userApi.getManazUser().subscribe({
            next: async (user) => {  // mettre async ici
                user.appUserRoles = await this.isApp(user.appUserRoles) // await OK
                this._user.set(user)
                this._loading.set(false)
            },
            error: err => {
                console.error('Erreur lors du chargement utilisateur', err)
                this._loading.set(false)
            }
        })
    }

    private async isApp(appUserRoles: AppUserRoles[] | null): Promise<AppUserRoles[] | null> {
        if (!appUserRoles) return null

        try {
            // attend la réponse HTTP avant de continuer
            const appConfigList = await firstValueFrom(this._userApi.getAppConfig())

            // met à jour appUserRoles après réception
            appUserRoles.forEach(x => {
                const appConfig: AppConfig | null = appConfigList.filter(b => b.app?.toLowerCase() === x.appId?.toLowerCase())[0]
                if (appConfig) {
                    x.isApp = true
                    switch (appConfig.server) {
                        case 'iis':
                            x.url = this._appSettingService.appSetting()?.service?.baseUrl?.iis!
                            break
                        case 'kubernetes':
                            x.url = this._appSettingService.appSetting()?.service?.baseUrl?.kubernetes!
                            break
                    }
                }

            })

            console.log('✅ appConfig reçu', appConfigList)
            console.log('🔁 appUserRoles mis à jour', appUserRoles)

            return appUserRoles // ici, ils sont bien à jour
        } catch (err) {
            console.error('❌ Erreur lors du chargement utilisateur', err)
            return appUserRoles
        }
    }

    // private async loadJson(): string {
    //   const response = await fetch('https://mon-serveur.com/config.json');
    //   if (!response.ok) throw new Error('Erreur de chargement');
    //   const data = await response.json();
    //   console.log('Config chargée:', data);

    //   return data;
    // }

    //  private async checkImage(url: string): Promise<boolean> {
    //  return new Promise(resolve => {
    //   const img = new Image();

    //   img.onload = () => {
    //     console.log(`[Image OK] ${url}`);  // ✅ L'image a bien chargé
    //     resolve(true);
    //   };

    //   img.onerror = () => {
    //     console.warn(`[Image manquante] ${url}`); // ⚠️ L'image n'existe pas
    //     resolve(false);
    //   };

    //   console.log(`[Check image] Lancement du test pour ${url}`);
    //   img.src = url; // ← c'est ici que l'image est "utilisée" pour le test
    //   });
    // }
}


